import React from 'react'
import CommonInformationList from '../../../common/pages/secure/InformationList'
import Config from '../../../Config'

class InformationList extends CommonInformationList {
  constructor (props) {
    super(props)
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  onPageMenuClicked (name) {
    switch (name) {
      case 'add':
        this.props.history.push('/admin/information/add')
        break
      default:
        break
    }
  }
  renderPageNavi () {
    return (
      <section className='nav-page'>
        <div className='container'>
          <div className='row'>
            <div className='span8'>
              <header className='page-header'>
                <h3>事務局からのお知らせ一覧<br />
                  <small>こちらから事務局からのお知らせを管理できます。</small>
                </h3>
              </header>
            </div>
            <div className='span8'>
              <ul className='nav nav-pills'>
                <li className='kw-btn-area'>
                  <a rel='tooltip' data-placement='left' title='新規のお知らせを登録' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('add')}>
                    <i className='icon-plus icon-large' /><br /><span>新規</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default InformationList



// WEBPACK FOOTER //
// ./src/admin/pages/secure/InformationList.js